/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.referral").
controller("ReferAFriendRouteController", function ReferAFriendRouteController(
	$http,
	$location,
	dxSession,
	validationService
) {
	"use strict";

	var self = this;

	self.emails = [];
	self.emails[0] = {address: "", validationWarning: ""};
	self.emails[1] = {address: "", validationWarning: ""};
	self.emails[2] = {address: "", validationWarning: ""};
	self.emails[3] = {address: "", validationWarning: ""};
	self.emails[4] = {address: "", validationWarning: ""};

	var searchObject = $location.search();
	self.campaign = searchObject.campaign || "";
	self.link = "https://app.digiexam.com/signup/?refKey=" + dxSession.getUser().id + "_" + self.campaign;
	self.buttonDisabled = false;

	self.emailChanged = function emailChanged(email) {
		email.validationWarning = "";
		clearOnSendMessages();
	};

	self.validateEmail = function validateEmail(email) {
		if (email.address && !validationService.isEmailValid(email.address)) {
			email.validationWarning = "Referral.MustBeValidEmail";
			return false;
		}

		email.validationWarning = "";
		return true;
	};

	self.selectAllText = function selectAllText(event) {
		var target = event.target;

		// setSelectionRange(0, this.value.length) instead of select() for mobile Safari capability
		target.setSelectionRange(0, target.value.length);
	};

	self.send = function send() {
		var i = 0;

		clearOnSendMessages();

		var allEmailsAreBlank = self.emails.every(function isEmailBlank(email) {
			return !email.address;
		});

		if (allEmailsAreBlank) {
			self.warningMessage = "Referral.EnterAtLeastOneEmail";
			return;
		}

		for (i = 0; i < self.emails.length; i++) {
			if (!self.validateEmail(self.emails[i])) {
				self.warningMessage = "Referral.AtLeastOneEmailInvalid";
				return;
			}
		}

		self.buttonDisabled = true;

		var recipients = [];
		for (i = 0; i < self.emails.length; i++) {
			var emailAddress = self.emails[i].address;

			if (emailAddress) {
				emailAddress = emailAddress.trim();

				if (emailAddress && recipients.indexOf(emailAddress) === -1) {
					recipients.push(emailAddress);
				}
			}
		}
		sendReferralCreateRequest(recipients, self.campaign);
	};

	function sendReferralCreateRequest(recipients, campaign) {
		$http({
			method: "POST",
			url: "/referral/create",
			data: JSON.stringify({
				recipients: recipients,
				source: "refer-a-friend",
				campaign: campaign,
			}),
		}).then(successCallback, errorCallback);
	}

	function successCallback() {
		self.successMessage = "Referral.EmailsSendSuccessful";

		for (var i = 0; i < self.emails.length; i++) {
			self.emails[i].address = "";
		}

		self.buttonDisabled = false;
	}

	function errorCallback() {
		self.errorMessage = "Referral.EmailsSendError";
		self.buttonDisabled = false;
	}

	function clearOnSendMessages() {
		self.warningMessage = "";
		self.successMessage = "";
		self.errorMessage = "";
	}
});
